import React from "react";
import { useFeedback } from "../../contexts/FeedbackContext";

export default function SoundControlsInline() {
  const { prefs, setSoundEnabled, setHapticsEnabled, setVolume, play, buzz } = useFeedback();

  return (
    <div className="rounded-2xl border p-3 space-y-3">
      <div className="font-medium">Sound & Haptics</div>

      <Row
        label="Enable sounds"
        control={<Toggle checked={!!prefs.soundEnabled} onChange={setSoundEnabled} />}
      />
      <Row
        label="Enable haptics"
        hint="Phone vibration or native haptics where supported"
        control={<Toggle checked={!!prefs.hapticsEnabled} onChange={setHapticsEnabled} />}
      />

      <div>
        <div className="text-sm font-medium">Volume</div>
        <div className="flex items-center gap-3 mt-1">
          <input
            type="range"
            min={0}
            max={100}
            value={Math.round((prefs.volume || 0) * 100)}
            onChange={(e) => setVolume(Number(e.target.value) / 100)}
            className="w-56"
          />
          <div className="text-sm opacity-70 w-10 text-right">
            {Math.round((prefs.volume || 0) * 100)}%
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <button className="px-3 py-1 rounded-xl border" onClick={() => (play("tap"), buzz("light"))}>Tap</button>
        <button className="px-3 py-1 rounded-xl border" onClick={() => (play("success"), buzz("success"))}>Success</button>
        <button className="px-3 py-1 rounded-xl border" onClick={() => (play("error"), buzz("error"))}>Error</button>
        <button className="px-3 py-1 rounded-xl border" onClick={() => (play("wake"), buzz("light"))}>Wake</button>
      </div>

      <div className="text-xs opacity-60">
        Tip: If you still hear nothing, click any button once to “unlock” audio, verify files exist under <code>/public/sfx/</code>, and check device mute.
      </div>
    </div>
  );
}

function Row({ label, hint, control }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div>
        <div className="text-sm font-medium">{label}</div>
        {hint && <div className="text-xs opacity-60">{hint}</div>}
      </div>
      <div className="shrink-0">{control}</div>
    </div>
  );
}

function Toggle({ checked, onChange }) {
  return (
    <button
      onClick={() => onChange(!checked)}
      className={`w-12 h-7 rounded-full p-1 transition-colors ${checked ? "bg-emerald-500" : "bg-gray-300"}`}
      aria-pressed={checked}
      type="button"
    >
      <span className={`block w-5 h-5 bg-white rounded-full shadow transition-transform ${checked ? "translate-x-5" : "translate-x-0"}`} />
    </button>
  );
}
